__turbopack_context__.v({
  "container": "index-module__MwXDNW__container",
});
